"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderDayContents = void 0;

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var INDICATION_COLORS = {
  1: 'var(--grey1)',
  2: 'var(--darklime)',
  3: 'var(--darklime)',
  4: 'var(--darklime)'
};

var renderDayContents = function renderDayContents(_ref) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      searchCalendarDuration = _ref.searchCalendarDuration,
      indicationMap = _ref.indicationMap,
      directFlightsInfo = _ref.directFlightsInfo,
      isHotelVariant = _ref.isHotelVariant;
  return (// eslint-disable-next-line react/display-name
    function (day, d) {
      var _directFlightsInfo$fo, _directFlightsInfo$fo2;

      var date = d;
      var isEndDay = (0, _isEqual2["default"])(date, endDate);
      var isStartDay = (0, _isEqual2["default"])(date, startDate);
      var isInSelectedInterval = (0, _utils.isBetweenDates)(date, {
        start: startDate,
        end: endDate
      });
      var formattedCurrentDate = (0, _format["default"])(date, 'yyyy-MM-dd');
      /** эта штука нужна чтобы узнать выгодная дата или нет */

      var isProfitable = Boolean(!startDate && !endDate && !isEndDay && !isStartDay && !isInSelectedInterval && indicationMap.get((0, _format["default"])(date, 'yyyy-MM-dd')));
      var hasDirectFlight = Boolean( // кейс, когда еще не выбран день вылета
      !startDate && !endDate && ((_directFlightsInfo$fo = directFlightsInfo[(0, _format["default"])(date, 'yyyy-MM-dd')]) === null || _directFlightsInfo$fo === void 0 ? void 0 : _directFlightsInfo$fo.length) > 0 || // кейс, когда выбран день вылета
      startDate && !endDate && ((_directFlightsInfo$fo2 = directFlightsInfo[(0, _format["default"])(startDate, 'yyyy-MM-dd')]) === null || _directFlightsInfo$fo2 === void 0 ? void 0 : _directFlightsInfo$fo2.find(function (endDate) {
        return endDate === formattedCurrentDate;
      })));
      var calendarDuration = d && (searchCalendarDuration === null || searchCalendarDuration === void 0 ? void 0 : searchCalendarDuration.find(function (_ref2) {
        var date = _ref2.date,
            startDatePrice = _ref2.startDate;
        return startDate && // вытаскиваем день из массива
        (0, _isEqual2["default"])(new Date((0, _format["default"])(date, 'MM/dd/yyyy')), d) && (0, _isEqual2["default"])(new Date((0, _format["default"])(startDatePrice, 'MM/dd/yyyy')), startDate) && ( // покрываем кейс когда выбрана только дата вылета
        !endDate && // чтобы на стартовую дату не залезали цены
        (0, _isBefore["default"])(new Date((0, _format["default"])(startDate, 'MM/dd/yyyy')), new Date((0, _format["default"])(date, 'MM/dd/yyyy'))) || // покрываем кейс когда выбраны две даты
        endDate && // а тут проверяем чтобы цена была на конечной дате и все
        (0, _isEqual2["default"])(new Date((0, _format["default"])(date, 'MM/dd/yyyy')), new Date((0, _format["default"])(endDate, 'MM/dd/yyyy'))));
      }));
      var price = calendarDuration === null || calendarDuration === void 0 ? void 0 : calendarDuration.fullPrice;
      var priceColor = calendarDuration === null || calendarDuration === void 0 ? void 0 : calendarDuration.colorNumber;
      return /*#__PURE__*/_react["default"].createElement(StyledCell, {
        $startShift: isStartDay,
        $endShift: isEndDay,
        $hasDirectFlight: hasDirectFlight,
        $isHotelVariant: isHotelVariant
      }, /*#__PURE__*/_react["default"].createElement(CellContent, null, /*#__PURE__*/_react["default"].createElement("span", null, day), /*#__PURE__*/_react["default"].createElement(Price, {
        $isActive: isEndDay,
        $indicationType: priceColor,
        $isProfitable: isProfitable,
        $isMobile: isMobile,
        $isHotelVariant: isHotelVariant
      }, /*#__PURE__*/_react["default"].createElement("span", null, price === null || price === void 0 ? void 0 : price.toLocaleString('ru-RU', {
        useGrouping: true
      })), isProfitable ? /*#__PURE__*/_react["default"].createElement("span", null, "\u0432\u044B\u0433\u043E\u0434\u043D\u043E") : null)));
    }
  );
};

exports.renderDayContents = renderDayContents;

var Price = _styledComponents["default"].div.withConfig({
  displayName: "renderDayContents__Price",
  componentId: "sc-1wclajr-0"
})(["position:absolute;bottom:2px;left:0;right:0;font-weight:400;font-size:10px;line-height:12px;text-align:center;height:12px;width:100%;color:", ";"], function (_ref3) {
  var $isActive = _ref3.$isActive,
      $indicationType = _ref3.$indicationType,
      $isProfitable = _ref3.$isProfitable,
      $isHotelVariant = _ref3.$isHotelVariant;

  if ($isProfitable) {
    return 'var(--darklime)';
  }

  if ($isActive || !$indicationType) {
    if ($isHotelVariant) return 'var(--secondary-color)';
    return 'var(--secondary-header-color)';
  }

  return INDICATION_COLORS[$indicationType];
});

var CellContent = _styledComponents["default"].span.withConfig({
  displayName: "renderDayContents__CellContent",
  componentId: "sc-1wclajr-1"
})(["height:100%;display:flex;flex-direction:column;justify-content:center;font-size:16px;font-style:normal;font-weight:500;line-height:20px;"]);

var StyledCell = _styledComponents["default"].div.withConfig({
  displayName: "renderDayContents__StyledCell",
  componentId: "sc-1wclajr-2"
})(["position:relative;height:100%;box-sizing:border-box;", " ", " ", ""], function (_ref4) {
  var $hasDirectFlight = _ref4.$hasDirectFlight;
  return $hasDirectFlight && (0, _styledComponents.css)(["color:var(--black);background-color:var(--teallight);border-radius:var(--border-radius);"]);
}, function (_ref5) {
  var $startShift = _ref5.$startShift,
      $endShift = _ref5.$endShift,
      $isHotelVariant = _ref5.$isHotelVariant;
  return ($startShift || $endShift) && $isHotelVariant && (0, _styledComponents.css)(["border-radius:var(--border-radius);border:1px solid var(--secondary);border-top:1px solid (--secondary);border-bottom:1px solid (--secondary);color:var(--secondary-color);background-color:var(--secondary) !important;"]);
}, function (_ref6) {
  var $startShift = _ref6.$startShift,
      $endShift = _ref6.$endShift,
      $isHotelVariant = _ref6.$isHotelVariant;
  return ($startShift || $endShift) && !$isHotelVariant && (0, _styledComponents.css)(["border-radius:var(--border-radius);border:1px solid var(--secondary-header);border-top:1px solid (--secondary-header);border-bottom:1px solid (--secondary-header);color:var(--secondary-header-color);background-color:var( --secondary-header ) !important;// \u043D\u0443\u0436\u043D\u043E,\u0447\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u043A\u0440\u044B\u0442\u044C \u0446\u0432\u0435\u0442 \u043F\u0440\u044F\u043C\u043E\u0433\u043E \u043F\u0435\u0440\u0435\u043B\u0435\u0442\u0430"]);
});